export default __webpack_public_path__ + "static/media/csi_worship_resource_inactive.b981bbc3.svg";